
            const data = {"name":"calendar","data":{"width":"18","height":"20","viewBox":"0 0 18 20","data":"<path pid=\"0\" d=\"M16 20H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h2V0h2v2h6V0h2v2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2ZM2 8v10h14V8H2Zm0-4v2h14V4H2Zm10 10H6v-2h6v2Z\" _fill=\"#909090\"/>","originalColors":[{"type":"fill","color":"#909090"}],"stopColors":[]}}
        
                    module.exports = data
                    